<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "global-filter-panel"
})
</script>

<template>
    <div class="background light global-filter-panel">
        <div class="container">
            <slot />
        </div>
    </div>
</template>
